import IconStudent from './IconStudent';

export default IconStudent;
